import { cn } from '@/shared/utils/cn';
import type { Rarity } from '@/shared/types/rarity';
import AceA from '@/assets/icons/ace-a.svg?react';
import SpadeSuit from '@/assets/icons/spade-suit.svg?react';
import { premiumRarityBackgrounds } from '@/shared/utils/rarity';
import { cva } from 'class-variance-authority';

const premiumCardBorderVariants = cva(
  'absolute z-20 flex size-11 flex-col items-center justify-center rounded-tl-[18px] rounded-br-3xl shadow-[4px_4px_0_4px_black]',
  {
    variants: {
      rarity: {
        COMMON: premiumRarityBackgrounds.COMMON,
        UNCOMMON: premiumRarityBackgrounds.UNCOMMON,
        RARE: premiumRarityBackgrounds.RARE,
        EPIC: premiumRarityBackgrounds.EPIC,
        LEGENDARY: premiumRarityBackgrounds.LEGENDARY,
      },
      placement: {
        topLeft: 'top-0 left-0',
        topRight: '-top-0.5 -right-0.5 scale-x-[-1]',
        bottomRight: 'right-0 bottom-0 rotate-180',
        bottomLeft: 'left-0 bottom-0 rotate-180 scale-x-[-1]',
      },
      compact: {
        true: 'size-7 rounded-tl-xl rounded-br-xl shadow-[2px_2px_0_2px_black]',
        false: '',
      },
    },
  },
);

type CornerPlacement = 'topLeft' | 'topRight' | 'bottomRight' | 'bottomLeft';

interface PremiumCornerBadgeProps {
  placement: CornerPlacement;
  rarity: Rarity;
  compact?: boolean;
}

export function PremiumCornerBadge({
  placement,
  rarity,
  compact = false,
}: PremiumCornerBadgeProps) {
  return (
    <div
      className={cn(premiumCardBorderVariants({ rarity, placement, compact }))}
    >
      {!compact && <AceA className="size-3.5 text-black" />}
      <SpadeSuit className="size-3.5 text-black" />
    </div>
  );
}

interface PremiumCardBorderProps {
  rarity: Rarity;
  corners?: 'top' | 'bottom' | 'both';
}

export function PremiumCardBorder({
  rarity,
  corners = 'both',
}: PremiumCardBorderProps) {
  const showTop = corners === 'top' || corners === 'both';
  const showBottom = corners === 'bottom' || corners === 'both';

  return (
    <>
      {showTop && <PremiumCornerBadge placement="topLeft" rarity={rarity} />}
      {showBottom && (
        <PremiumCornerBadge placement="bottomRight" rarity={rarity} />
      )}
    </>
  );
}
